function variantPicker(){
  const productRelated = document.querySelector('product-recommendations.related-products');

  if (!window.ulankaQuickAddSizesInitialized) {
    window.ulankaQuickAddSizesInitialized = true;
    document.addEventListener('click', handleQuickAddSizeClick, true);
  }

  function handleQuickAddSizeClick(event) {
    const target = event.target.closest('variant-radios-card label.tallas, variant-radios-card input[data-name="Tallas"]');

    if (!target) return;

    const variantRadios = target.closest('variant-radios-card');
    const label = target.matches('label.tallas')
      ? target
      : variantRadios?.querySelector(`label[for="${target.id}"]`);
    const input = target.matches('input')
      ? target
      : document.getElementById(label?.getAttribute('for'));

    if (!variantRadios || !input || input.classList.contains('disabled')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    input.checked = true;

    const variantsJson = variantRadios.querySelector('script');
    if (!variantsJson) return;

    const variants = JSON.parse(variantsJson.textContent);
    const variant = getVariantDataFromClickedInput(variants, input, variantRadios);

    if (variant?.available) {
      addVariantToCart(variant.id, label || input);
    }
  }
  
  function handleProductVariants(target = document) {
    const botones_Tallas = target.querySelectorAll('input[data-name="Tallas"]');
    botones_Tallas.forEach(function (boton, idx) {
      boton.classList.add('initialized');
      const variants = JSON.parse(
        boton.closest("variant-radios-card").querySelector("script").textContent
      );
      boton.addEventListener("click", function (element) {
        let Tallas, color;
        const labels = element.currentTarget.closest('fieldset').querySelectorAll('label');
        labels.forEach(label => {
          if (label && label.title == boton.value) {
            const labelSpinner = label.querySelector('span.loader-letter');
            console.log(labelSpinner);
            if (labelSpinner.classList.contains('hidden')) {
              labelSpinner.classList.remove('hidden');
              setTimeout(() => {
                labelSpinner.classList.add('hidden');
              }, 3000);
            }else{
              console.log('no entro')
            }
          }
        });
        Tallas = boton.closest("variant-radios-card").querySelector('input[data-name="Tallas"]:checked')?.value;
        color = boton.closest("variant-radios-card").querySelector('input[data-name="Color"]:checked')?.value || "";
        const variant = getVariantData(variants, [Tallas, color]);
        const submitButton = boton.closest(".grid__item, .row_ccu-carrousel").querySelector(".quick-add__submit");
        addToCart(variant, submitButton);
      });
    });

    const botones_color_Tallas = target.querySelectorAll('input[data-name="Color"]:not(.initialized), input[data-name="Tallas"]:not(.initialized)');
    botones_color_Tallas.forEach(function (boton) {
      boton.classList.add('initialized');
      const variants = JSON.parse(
        boton.closest("variant-radios-card").querySelector("script").textContent
      );
      updateInit(boton, variants);
    });
  }

  // Ejecutar la función principal al cargar el documento
  handleProductVariants();

  // Configurar el MutationObserver
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            handleProductVariants(node);
          }
        });
      }
    });
  });

  // Iniciar la observación si productRelated existe
  if (productRelated) {
    observer.observe(productRelated, { childList: true, subtree: true });
  }

  function updateInit(boton, producto) {
    const Tallas = boton.closest("variant-radios-card")?.querySelector('input[data-name="Tallas"]:checked')?.value;
    const color = boton.closest("variant-radios-card")?.querySelector('input[data-name="Color"]:checked')?.value;
    const data = getVariantData(producto, [Tallas, color]);
    const price = boton.closest(".grid__item, .row_ccu-carrousel").querySelector(".price__sale .price-item");
    const compared_at_price = boton.closest(".grid__item, .row_ccu-carrousel").querySelector(".price__sale .price-item--regular");
    const variant_price = data?.price;
    const variant_compared_at_price = data?.compare_at_price;
    if (price && variant_price != null) {
      price.innerHTML = Shopify.formatMoney(
        variant_price,
        "{{amount_with_comma_separator}} €"
      );
    }
    if (compared_at_price) {
      compared_at_price.innerHTML = Shopify.formatMoney(
        variant_compared_at_price,
        "{{amount_with_comma_separator}} €"
      );
      compared_at_price.style.display = variant_compared_at_price ? "inline" : "none";
    }
  }

  function addToCart(variant, submitButton) {
    const variantInput = submitButton.closest("form").querySelector('input[name="id"]');
    variantInput.value = variant.id;
    submitButton.disabled = !variant.available;

    if (variant.available) {
      submitButton.click();
    }
  }

  function addVariantToCart(variantId, trigger) {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const config = typeof fetchConfig === 'function'
      ? fetchConfig('javascript')
      : {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
          },
        };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(trigger);
    }

    trigger.setAttribute('aria-busy', 'true');
    config.body = formData;

    const cartAddUrl = window.routes?.cart_add_url || '/cart/add.js';

    fetch(cartAddUrl, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.description);
          return;
        }

          if (!cart) {
            return;
          }

          cart.classList.remove('is-empty');
          cart.querySelector('.drawer__inner')?.classList.remove('is-empty');
          cart.querySelector('cart-drawer-items')?.classList.remove('is-empty');
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add-size' });
          cart.renderContents(response);
        })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        trigger.removeAttribute('aria-busy');
      });
  }

  function getVariant(variants, options) {
    return variants.find(variant => 
      options[1] === "" 
        ? variant.option1 === options[0]
        : variant.option2 === options[0] && variant.option1 === options[1]
    ) || null;
  }

  function getVariantData(variants, options) {
    const variant = getVariant(variants, options);
    if (!variant) return null;
    return {
      compare_at_price: variant.compare_at_price,
      price: variant.price,
      featured_image: variant.featured_image ? variant.featured_image.src : "",
      id: variant.id,
      available: variant.available
    };
  }

  function getVariantDataFromClickedInput(variants, clickedInput, variantRadios) {
    const clickedOptionPosition = getOptionPositionFromInput(clickedInput);
    const selectedOptions = getSelectedOptions(variantRadios);
    selectedOptions[clickedOptionPosition - 1] = clickedInput.value;

    let variant = variants.find((variant) => {
      return selectedOptions.every((optionValue, index) => {
        return !optionValue || variant[`option${index + 1}`] === optionValue;
      }) && variant.available;
    });

    if (!variant) {
      variant = variants.find((variant) => {
        return variant[`option${clickedOptionPosition}`] === clickedInput.value && variant.available;
      });
    }

    if (!variant) return null;

    return {
      compare_at_price: variant.compare_at_price,
      price: variant.price,
      featured_image: variant.featured_image ? variant.featured_image.src : "",
      id: variant.id,
      available: variant.available
    };
  }

  function getOptionPositionFromInput(input) {
    const idParts = input.id.split('-');
    const position = parseInt(idParts[idParts.length - 3], 10);

    return Number.isNaN(position) ? 1 : position;
  }

  function getSelectedOptions(variantRadios) {
    const checkedInputs = variantRadios.querySelectorAll('input[type="radio"]:checked');
    const options = [];

    checkedInputs.forEach((input) => {
      const position = getOptionPositionFromInput(input);
      options[position - 1] = input.value;
    });

    return options;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    variantPicker();
  }, 500);
});
